import VueSlickCarousel from 'vue-slick-carousel'
import FormLanding from '../forms/landing'
import Highlights from '../components/highlights'
import { Slider, SliderItem } from '../components/slider'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'LandingPage',
  components: {
    Highlights,
    FormLanding,
    VueSlickCarousel,
    Slider,
    SliderItem,
  },
  data() {
    return {
      sliderOptions: {
        arrows: false,
        autoplay: true,
        swipe: false,
        autoplaySpeed: 0,
        slidesToShow: 6,
        speed: 3000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
            },
          },
        ]
      },
      testimonialSliderOptions :{
        arrows: true,
        slidesToShow: 1,
        speed: 500,
        cssEase: 'linear'
      },
      clientSliderOptions: {
        arrows: false,
        autoplay: true,
        swipe: false,
        autoplaySpeed: 0,
        slidesToShow: 6,
        speed: 3000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    }
  },
}
